import styled from 'styled-components';

export const SelectContainer = styled.div`
  max-width: 266px;
`;
